export default __webpack_public_path__ + "images/fcb062715a5cc96476d07397d65d38b8.png";